import { useInbox } from "@/monitors/api";
import { MatchCard } from "@/monitors/components/MatchCard";

export function MatchesInboxPage() {
  const { data, isLoading, isError } = useInbox({ stage: "confirmed", limit: 100 });
  const matches = data?.matches ?? [];

  return (
    <div className="p-6 max-w-4xl mx-auto">
      <h1 className="text-2xl font-semibold mb-4">All matches</h1>

      {/* Filters deferred to v1.1 — URL search params will plug in without
          changing the data layer. */}

      {isLoading && <p className="text-muted-foreground">Loading…</p>}
      {isError && <p className="text-red-600">Couldn't load matches.</p>}
      {!isLoading && matches.length === 0 && (
        <p className="text-muted-foreground">
          No matches yet. When a monitor fires, you'll see it here.
        </p>
      )}

      <ul className="space-y-3">
        {matches.map((m) => (
          <li key={m.id}>
            <MatchCard match={m} monitorName={m.monitor_id ?? ""} size="md" showWhy />
          </li>
        ))}
      </ul>
    </div>
  );
}
